import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";

var Material = function Material() {
  _classCallCheck(this, Material);
};

export { Material as default };
//# sourceMappingURL=material.js.map